import { useContext, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'libraries/redux'
import { ProductSelectors } from 'store/product/selectors'

// import { createOrder } from 'store/wishlist/actions'
import { showNotification, ToastVersions } from 'libraries/toastify'
import { useNavigate } from 'react-router-dom'

import { useIntersectionObserver } from 'usehooks-ts'
import { SupplierContext } from 'context/SupplierContext'
import { useFetchSupplierProductsListMutation } from '../../ProductDetails/api/suppliers/apiProductSlice'
import { CategoriesSelectors } from 'store/category/selectors'
import { useGetCartItemsQuery } from '../api/apiCartSlice'
import {
  useCreateOrderMutation,
  useFetchCountriesQuery,
  useGetPaymentMethodQuery,
  useOrderDeliveryMethodsQuery,
} from '../api/api2/apiOrderSlice'
import { NovaSelectors } from 'store/novaposhta/selectors'
import { getCities, getWarehouses } from 'store/novaposhta/actions'
import { DELIVERY_COURIER, DELIVERY_INTERNATIONAL } from 'shared/constants'
import { useBasketForm } from 'shared/hooks/Basket/useBasketForm'
import useCategoryIds from 'shared/hooks/Categories/useCategoryIds'

export const useBasketInformation = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { state, setters, validate } = useBasketForm()

  const [openModalForManualCheck, setOpenModalForManualCheck] = useState(false)

  const { data: productList, loading } = useAppSelector(ProductSelectors.productList)
  const { data: citiesList } = useAppSelector(NovaSelectors.citiesList)
  const { data: warehousesList } = useAppSelector(NovaSelectors.warehousesList)
  const { data: storeInfo } = useAppSelector(CategoriesSelectors.storeInfo)
  const { data: countryList } = useFetchCountriesQuery({
    page: 1,
    searchValue: '',
  })

  const [createOrder] = useCreateOrderMutation()
  const { categoryIds, isLoading: categoriesLoading } = useCategoryIds()
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState('')
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('')

  //For Supplier
  const { is_supplier } = useContext(SupplierContext)
  const merchant_id = is_supplier ? Number(window.config.CUSTOMER_ID) : 0

  const { data: deliveryMethods, isLoading: isDeliveryLoading } = useOrderDeliveryMethodsQuery({
    merchant_id: merchant_id,
  })
  const {
    data: paymentMethods,
    isLoading: isPaymentLoading,
    refetch: refetchPaymentMethods,
  } = useGetPaymentMethodQuery(
    {
      merchant_id: merchant_id,
      delivery_method_code: selectedDeliveryMethod,

      // custom_ttn: "1231213231231321",
    },
    {
      skip: !selectedDeliveryMethod,
    }
  )

  const {
    data: basketList,
    isLoading: basketListLoading,
    refetch: refetchCart,
  } = useGetCartItemsQuery({
    per_page: 20,
    page: 1,
    merchant_id: merchant_id,
  })

  const [fetchProducts, { data: popularPorducts }] = useFetchSupplierProductsListMutation()
  const renderBasketCartInformation = basketList

  /// End suppluers
  useEffect(() => {
    if (selectedDeliveryMethod) {
      refetchPaymentMethods()
    }
    if (is_supplier && !categoriesLoading) {
      fetchProducts({
        customer_id: merchant_id,
        category_filter: categoryIds,
        page: 1,
        per_page: 20,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDeliveryMethod])

  useEffect(() => {
    setSelectedPaymentMethod('')
  }, [selectedDeliveryMethod])

  const getCitiesList = () => {
    dispatch(getCities({ page: state.citiesPage, search: state.citiesSearch }))
  }

  const getWarhousesList = () => {
    dispatch(getWarehouses({ page: state.warehousePage, ref: state.cityRef, search: state.warehouseSearch }))
  }
  const handleOpenOrderModal = () => {
    setters.setIsOpenModal(true)
    getCitiesList()
  }

  const trackFacebookEvent = (eventName: string, params?: Record<string, any>) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', eventName, params)
    }
  }
  const trackTikTokEvent = (eventName: string, params?: Record<string, any>) => {
    if (typeof window !== 'undefined' && window.ttq) {
      window.ttq.track(eventName, params)
    }
  }
  const trackGAEvent = (eventName: string, params: any) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params || {})
    } else {
      console.warn(`gtag is not available for event: ${eventName}`)
    }
  }

  const handleOrderClick = async () => {
    const isValid = validate(selectedDeliveryMethod)
    if (!isValid) {
      return
    }

    setters.setIsLoadingOrder(true)

    const body = {
      merchant_id: is_supplier ? Number(window.config.CUSTOMER_ID) : 0,
      delivery_method_code: selectedDeliveryMethod,
      payment_method_code: selectedPaymentMethod,
      firstname: state.firstName,
      lastname: state.lastName,
      telephone: state.phone,
      city_ref: state.cityRef,
      warehouse_ref: state.warehouseRef || '',
      total_pay: selectedPaymentMethod === 'cod' ? basketList?.summary?.total_recommended : null,
      shipping_street_id: selectedDeliveryMethod === DELIVERY_COURIER ? state.cityID.toString() : null,
      shipping_flat: selectedDeliveryMethod === DELIVERY_COURIER ? state.apartment : null,
      shipping_house: selectedDeliveryMethod === DELIVERY_COURIER ? state.house : null,
      city: selectedDeliveryMethod === DELIVERY_INTERNATIONAL ? state.internationalCity : state.cityName,
      address: selectedDeliveryMethod === DELIVERY_INTERNATIONAL ? state.countryHouse : state.warehouseName,
      email: selectedDeliveryMethod === DELIVERY_INTERNATIONAL ? state.email : null,
      middlename: selectedDeliveryMethod === DELIVERY_INTERNATIONAL ? state.middleName : null,
      country_id: selectedDeliveryMethod === DELIVERY_INTERNATIONAL ? state.country : 1,
      category_order_id: null,
      custom_customer_id: null,
      comment: '',
    }


    try {
      const payload = await createOrder({ body: body }).unwrap()
      console.log('🎉 ORDER SUCCESS RESPONSE:', payload)
      console.log('📦 BASKET DATA:', basketList)
      console.log('🚚 DELIVERY INFO:', {
        cityName: state.cityName,
        warehouseName: state.warehouseName,
        deliveryMethod: selectedDeliveryMethod,
      })
      refetchCart()
      if (payload?.url && selectedPaymentMethod === 'bank_transfer') {
        window.location.href = payload.url
      }

      if (payload?.warning) {
        showNotification(ToastVersions.warning, payload?.warning)
      } else {
        if (payload?.status === 1) {
          if (storeInfo?.fb_pixel_id) {
            trackFacebookEvent('Purchase', {
              content_ids: basketList?.data?.map((item: any) => ({
                id: item?.product_id,
                quantity: item?.quantity,
                item_price: item?.price,
              })),
              value: basketList?.total_format,
              currency: 'UAH',
              content_type: 'product',
            })
          }

          if (storeInfo?.tt_pixel_id) {
            ;(window as any).ttq.identify({
              phone: state.phone,
            }),
              trackTikTokEvent('Purchase', {
                content_ids: basketList?.data?.map((item: any) => ({
                  id: item?.product_id,
                  quantity: item?.quantity,
                  item_price: item?.price,
                  name: item?.name,
                })),
                value: basketList?.total,
                currency: 'UAH',
                content_type: 'product',
                phone: state.phone,
                name: state.firstName + ' ' + state.lastName,
                city: [state.cityRef],
              })
          }
          if (storeInfo?.ga_tracking_id) {
            trackGAEvent('purchase', {
              transaction_id: payload?.order_id || Date.now().toString(),
              value: basketList?.total,
              currency: 'UAH',
              items: basketList?.data?.map((item: any) => ({
                item_id: String(item?.product_id),
                item_name: item?.name,
                quantity: item?.quantity,
                price: item?.price,
              })),
            })
          }

          if (selectedPaymentMethod === 'bank_transfer_manual_check') {
            setOpenModalForManualCheck(true)

            return
          }

          showNotification(ToastVersions.success, 'Заказ успішно створений')
          navigate('/order-success', {
            state: {
              orderId: payload?.order_id,
              items: basketList?.data || [],
              total: basketList?.summary?.total_recommended || basketList?.total,
              deliveryInfo: state.warehouseName ,
            },
          })
        } else {
          showNotification(ToastVersions.success, 'Заказ успішно створений')
        }
      }
      setters.setIsLoadingOrder(false)
      setters.setIsOpenModal(false)
    } catch (error) {
      console.error('Error creating order:', error)
      showNotification(ToastVersions.error, 'Failed to create order. Please try again.')
      setters.setIsLoadingOrder(false)
    }
  }

  const [lastWarehouseRef, entryWarehouse] = useIntersectionObserver({
    threshold: 0.5,
    root: null,
    rootMargin: '2px',
  })

  const [lastCityRef, entryCities] = useIntersectionObserver({
    threshold: 0.5,
    root: null,
    rootMargin: '2px',
  })

  useEffect(() => {
    if (state.cityRef.length > 0) {
      getWarhousesList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.cityRef])

  useEffect(() => {
    if (entryWarehouse) {
      setters.setWarehousePage(prev => prev + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryWarehouse])

  useEffect(() => {
    if (entryCities) {
      setters.setCitiesPage(prev => prev + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryCities])

  useEffect(() => {
    getCitiesList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.citiesSearch, state.citiesPage])

  useEffect(() => {
    if (state.warehousePage > 1) getWarhousesList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.warehousePage])

  useEffect(() => {
    if (state.cityRef.length > 0 && selectedDeliveryMethod !== 'novaposhta.courier') {
      getWarhousesList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.warehouseSearch])

  useEffect(() => {
    if (state.firstName && state.lastName && state.phone && state.cityRef && state.warehouseRef) {
      trackFacebookEvent('Lead', {
        first_name: state.firstName,
        last_name: state.lastName,
        city: state.cityRef,
        warehouse: state.warehouseRef,
        contend: basketList?.data?.map((item: any) => item?.product_id),
        phone: state.phone,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.firstName, state.lastName, state.phone, state.cityRef, state.warehouseRef])

  return {
    ...state,
    ...setters,

    state,
    setters,

    // Логика
    handleOrderClick,
    handleOpenOrderModal,
    validate,

    // Платежи и доставка
    selectedDeliveryMethod,
    setSelectedDeliveryMethod,
    deliveryMethods,
    isDeliveryLoading,

    selectedPaymentMethod,
    setSelectedPaymentMethod,
    paymentMethods,
    isPaymentLoading,

    // Корзина
    basketList,
    basketListLoading,
    refetchCart,
    productList,
    loading,
    popularPorducts,

    // Гео
    citiesList,
    lastCityRef,
    warehousesList,
    lastWarehouseRef,
    countryList,

    // Флаги/состояния
    is_supplier,
    openModalForManualCheck,
    setOpenModalForManualCheck,
    navigate,
    renderBasketCartInformation,
  }
}
